import { render } from "./marcas.vue?vue&type=template&id=80730b8c"
import script from "./marcas.vue?vue&type=script&lang=js"
export * from "./marcas.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__